import { memo } from 'react'
import { InputBoxProps } from '@app/types/dashboard'
import { RootSelectorInput } from '../../inputs/root-selector-input'

export const RootSelectoroxWrapper = ({
  url,
  activeSubscription,
  translation,
  rootElement,
}: InputBoxProps & { rootElement?: string }) => {
  return (
    <RootSelectorInput
      activeSubscription={activeSubscription}
      value={rootElement}
      translation={translation}
      url={url}
    />
  )
}

export const RootSelectorBoxMock = memo(RootSelectoroxWrapper)
